var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"statistics-member",staticStyle:{"min-height":"400px"}},[_c('div',{staticClass:"common-form"},[_vm._v("访问统计")]),_vm._v(" "),_c('div',{staticClass:"d-s-stretch bd-box"},[_c('div',{staticClass:"d-s-c d-c left-box"},[(!_vm.loading)?_c('Total'):_vm._e(),_vm._v(" "),(!_vm.loading)?_c('LineChart'):_vm._e()],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f57b6b5","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/statistics/user/index.vue
// module id = null
// module chunks = 